import {
    RecentTriage,
    URGENCY_COLORS,
    URGENCY_LABELS,
} from '@/lib/api/dashboard/dashboard-api'
import { format, parseISO } from 'date-fns'
import { MdAccessTime, MdArrowForward, MdAssignment } from 'react-icons/md'
import { Link } from 'react-router-dom'

interface RecentTriagesTableProps {
    triages: RecentTriage[]
}

export default function RecentTriagesTable({ triages }: RecentTriagesTableProps) {
    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 overflow-hidden">
            <div className="bg-gradient-to-r from-warning/10 to-error/10 px-5 py-4 border-b border-base-300/50">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-2 rounded-lg bg-warning/20">
                            <MdAssignment className="text-warning text-lg" />
                        </div>
                        <h3 className="text-lg font-semibold text-base-content">
                            Triagens Recentes
                        </h3>
                    </div>
                    <Link
                        to="/bookings/triage"
                        className="btn btn-ghost btn-sm gap-1"
                    >
                        Ver todas
                        <MdArrowForward />
                    </Link>
                </div>
            </div>

            <div className="overflow-x-auto">
                {triages.length === 0 ? (
                    <div className="text-center py-8 text-base-content/50">
                        Nenhuma triagem recente
                    </div>
                ) : (
                    <table className="table table-sm">
                        <thead>
                            <tr className="text-xs text-base-content/60">
                                <th>Paciente</th>
                                <th>Urgência</th>
                                <th>Queixa Principal</th>
                                <th>Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            {triages.slice(0, 5).map(triage => (
                                <tr key={triage.id} className="hover">
                                    <td>
                                        <Link
                                            to={`/bookings/triage/${triage.id}`}
                                            className="font-medium text-base-content hover:text-secondary"
                                        >
                                            {triage.clientName}
                                        </Link>
                                    </td>
                                    <td>
                                        <span
                                            className="badge badge-sm font-medium"
                                            style={{
                                                backgroundColor: `${triage.urgencyColor || URGENCY_COLORS[triage.urgency]}20`,
                                                color: triage.urgencyColor || URGENCY_COLORS[triage.urgency],
                                            }}
                                        >
                                            {URGENCY_LABELS[triage.urgency] || triage.urgency}
                                        </span>
                                    </td>
                                    <td className="max-w-[200px]">
                                        <span className="text-xs text-base-content/70 line-clamp-2">
                                            {triage.chiefComplaint}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="flex items-center gap-1 text-base-content/60 text-xs">
                                            <MdAccessTime className="text-sm" />
                                            {format(parseISO(triage.triageAt), 'dd/MM HH:mm')}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
